import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { adminApi, getToken, setToken } from "./adminApi";
import { AdminLogin } from "./AdminLogin";
import { AdminDashboard } from "./AdminDashboard";

export default function AdminPage() {
  const [user, setUser] = useState(getToken() ? null : false);

  useEffect(() => {
    document.title = "Admin · Sweet Results";
    if (!getToken()) return;
    adminApi.me().then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const logout = useCallback(() => { setToken(null); setUser(false); }, []);

  if (user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-[#FF2A8D]" /></div>;
  if (!user) return <AdminLogin onDone={setUser} />;
  return <AdminDashboard user={user} onLogout={logout} />;
}
